/**
 * Affiliations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";
import AppConfig from "../../../constants/AppConfig";

// States
const state = {
    factures: [],

    facture: {}
};

// Getters
const getters = {
    factures: state => {
        return state.factures
    },


    facture: state => {
        return state.facture
    }
};

// Actions
const actions = {
    printFacture(context, payload){
        function successCallback(response) {
            let url= AppConfig.imgUrl+'/public/storage/pdf/'+response.data.name;
            let fileName = response.data.name;

            Vue.axios.get(
                url,{
                    responseType: 'blob', // important
                }
            ).then((response) => {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        }


        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Facture.Print, localToken, successCallback, errorCallback, payload.errorMessages);

    },

    printFactureProforma(context, payload){
        function successCallback(response) {
            let url= AppConfig.imgUrl+'/public/storage/pdf/'+response.data.name;
            let fileName = response.data.name;

            Vue.axios.get(
                url,{
                    responseType: 'blob', // important
                }
            ).then((response) => {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        }


        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Facture.PrintProforma, localToken, successCallback, errorCallback, payload.errorMessages);

    },

    getFactures(context, payload) {
        function successCallback(response) {
            context.commit('getFacturesHandler', { factures: response.data.factures });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Facture.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

   /* getFacturesAvis(context, payload) {
        function successCallback(response) {
            context.commit('getFactureAvisHandler', { facturesAvis: response.data.factureAvis });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.FactureAvis.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },*/

    getFacture(context, payload) {
        function successCallback(response) {
            context.commit('getFactureHandler', { facture: response.data.facture });
        }

        function errorCallback(error) {

            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Facture.Get, localToken, successCallback, errorCallback, payload.errorMessages);

    },

    createFacture(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'facture', params: { facture: response.data.facture.slug } });
        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Facture.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    mailRecouvrementFacture(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Facture.MailRecouvrement, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    mailRappelFacture(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Facture.MailRappel, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createFacturePrestation(context, payload) {
        function successCallback(response) {
            context.commit('getFactureHandler', { facture: response.data.facture });
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.FacturePrestation.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateFacture(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'facture' });
            router.push({ name: 'facture', params: { facture: response.data.facture.slug } });

        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Facture.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteFacture(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'facture' });
            router.push({ name: 'factures' });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Facture.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteFacturePrestation(context, payload) {
        function successCallback(response) {
            context.commit('getFactureHandler', { facture: response.data.facture });
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.FacturePrestation.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    validerFacturePrestation(context, payload) {
        function successCallback(response) {
            // context.commit('getFactureHandler', { facture: response.data.facture });
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.FacturePrestation.Valider, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    rejeterFacturePrestation(context, payload) {
        function successCallback(response) {
            // context.commit('getFactureHandler', { facture: response.data.facture });
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.FacturePrestation.Rejeter, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getFacturesHandler(state, { factures }) {
        // Update affiliations state
        state.factures = factures;
    },
    /*getFactureAvisHandler(state, { facturesAvis }) {
        // Update affiliations state
        state.facturesAvis = facturesAvis;
    },*/
    getFactureHandler(state, { facture }) {
        // Update affiliation state
        state.facture = facture;
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}